import { getConfidenceColor } from 'utils';

import { SnapDetailsLineItem } from 'codegen';
import {
  InitialTableActions,
  TColumn,
  TEditableColumn,
  TFieldProps,
} from 'types';

export const initialTableActions = [{
  type: InitialTableActions.Edit,
}, {
  type: InitialTableActions.Approve,
}, {
  type: InitialTableActions.Delete,
}];

export const columns: TEditableColumn<SnapDetailsLineItem>[] = [{
  width: 250,
  title: 'Item Name',
  dataIndex: 'name',
  field: {
    type: TFieldProps.type.Text,
    rules: [{
      message: 'Required',
      required: true,
    }],
  },
  getStyles: (record) => {
    const getBackground = getConfidenceColor(record);

    return { backgroundColor: getBackground('name') };
  },
}, {
  width: 250,
  title: 'Enriched line item',
  dataIndex: 'enrichedName',
}, {
  width: 140,
  title: 'Item SKU/UPC',
  dataIndex: 'sku',
  field: {
    type: TFieldProps.type.Text,
  },
  getStyles: (record) => {
    const getBackground = getConfidenceColor(record);

    return { backgroundColor: getBackground('sku') };
  },
}, {
  width: 100,
  title: 'Quantity',
  dataIndex: 'quantity',
  field: {
    type: TFieldProps.type.Number,
    min: 0.01,
    rules: [{
      type: 'number',
      min: 0.01,
      message: 'Min 0.01',
    }],
  },
  getStyles: (record) => {
    const getBackground = getConfidenceColor(record);

    return { backgroundColor: getBackground('quantity') };
  },
}, {
  type: TColumn.type.Currency,
  width: 110,
  title: 'Total Price',
  dataIndex: 'total',
  field: {
    type: TFieldProps.type.Currency,
    rules: [{
      message: 'Required',
      required: true,
    }],
  },
  getStyles: (record) => {
    const getBackground = getConfidenceColor(record);

    return { backgroundColor: getBackground('total') };
  },
}, {
  type: TColumn.type.Status,
  width: 150,
  title: 'Status',
  dataIndex: 'matchStatus',
}, {
  type: TColumn.type.Percent,
  width: 150,
  title: 'OCR Score',
  dataIndex: 'totalOcrScore',
}];
